<script>
import QuoteSlider from './Part/QuoteSlider.vue';

export default {
    components: {
        QuoteSlider
    },
    data() {
        return {
            data: {},
            togglePassword: false,
            toggleConfirmPassword: false
        }
    },
    mounted() {
        var vm = this;

        vm.load();
    },
    methods: {
        load() {
            var vm = this;

            vm.createEmptyData();
            vm.create();
        },
        async create() {
            var vm = this;

            this.$loading.on('reset_password_create');
            try {
                var params = {
                    token: vm.$route.query.token,
                };

                var resp = await vm.$api.Auth.verifyToken(params);
                var data = resp.data.data;

                vm.data.name = data.name;

                this.$loading.off('reset_password_create');
            } catch (err) {
                // this.$flash.error(err.response.data.message);
                const status = err.response?.status;

                if (status === 404) {
                    vm.$router.replace({ name: 'login' });
                }
            }
        },
        createEmptyData() {
            var vm = this;

            var data = {
                token: null,
                name: null,
                password: null,
                confirm_password: null,
            };

            vm.data = Object.assign({}, data);
        },
        _createPostData(data) {
            var vm = this;

            data.token = vm.$route.query.token;

            return data;
        },
        async submit() {
            var vm = this;

            try {
                vm.$loading.on('reset_password_submit');

                var data = vm._createPostData(vm.data);
                var resp = await vm.$api.Auth.resetPassword(data);

                vm.$router.push({ 'name': 'login' });

                vm.$flash.success(resp.data.message);
            } catch (error) {
                vm.$flash.error(error.response.data.message);
            }

            vm.$loading.off('reset_password_submit');
        },
    },
};
</script>

<template>
    <loading :loading="$loading.get('reset_password_create')" variant="dark" type="block">
        <div class="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
            <div class="bg-overlay"></div>
            <div class="auth-page-content overflow-hidden pt-lg-5">
                <BContainer>
                    <BRow>
                        <BCol lg="12">
                            <BCard no-body class="overflow-hidden m-0">
                                <BRow class="justify-content-center g-0">
                                    <BCol lg="6">
                                        <QuoteSlider />
                                    </BCol>

                                    <BCol lg="6">
                                        <div class="p-lg-5 p-4">
                                            <div>
                                                <h5 class="text-primary">{{ $t('reset_password.label.title') }}</h5>
                                                <p class="text-muted">
                                                    {{ $t('reset_password.label.sub_title', {
                                                        user:
                                                            data.name
                                                    }) }}
                                                </p>
                                            </div>

                                            <div class="mt-4">
                                                <b-form @submit="submit()">
                                                    <div class="mb-3">
                                                        <label class="form-label" for="password-input">{{
                                                            $t("reset_password.label.password") }} <span
                                                                class="text-danger">*</span></label>
                                                        <div class="position-relative auth-pass-inputgroup mb-3">
                                                            <input :type="togglePassword ? 'text' : 'password'"
                                                                class="form-control pe-5"
                                                                :placeholder="$t('reset_password.placeholder.password')"
                                                                id="password-input" v-model="data.password">
                                                            <BButton variant="link"
                                                                class="position-absolute end-0 top-0 text-decoration-none text-muted shadow-none"
                                                                type="button" id="password-addon"
                                                                @click="togglePassword = !togglePassword"><i
                                                                    class="ri-eye-fill align-middle"></i></BButton>
                                                        </div>
                                                    </div>
                                                    <div class="mb-3">
                                                        <label class="form-label" for="password-input">{{
                                                            $t("reset_password.label.confirm_password") }} <span
                                                                class="text-danger">*</span></label>
                                                        <div class="position-relative auth-pass-inputgroup mb-3">
                                                            <input :type="toggleConfirmPassword ? 'text' : 'password'"
                                                                class="form-control pe-5"
                                                                :placeholder="$t('reset_password.placeholder.confirm_password')"
                                                                id="password-input" v-model="data.confirm_password">
                                                            <BButton variant="link"
                                                                class="position-absolute end-0 top-0 text-decoration-none text-muted shadow-none"
                                                                type="button" id="password-addon"
                                                                @click="toggleConfirmPassword = !toggleConfirmPassword">
                                                                <i class="ri-eye-fill align-middle"></i>
                                                            </BButton>
                                                        </div>
                                                    </div>
                                                    <div class="mt-4">
                                                        <BButton variant="primary" class="w-100" type="submit"
                                                            :disabled="$loading.get('reset_password_submit')">
                                                            <loading :loading="$loading.get('reset_password_submit')">
                                                                {{ $t('reset_password.btn.save') }}
                                                            </loading>
                                                        </BButton>
                                                    </div>
                                                </b-form>
                                            </div>

                                            <div class="mt-5 text-center">
                                                <p class="mb-0">{{ $t('reset_password.label.signin') }}<router-link
                                                        :to="{ name: 'login' }"
                                                        class="fw-semibold text-primary text-decoration-underline">&nbsp;{{
                                                            $t('reset_password.btn.signin') }}
                                                    </router-link>
                                                </p>
                                            </div>
                                        </div>
                                    </BCol>
                                </BRow>
                            </BCard>
                        </BCol>

                    </BRow>
                </BContainer>
            </div>

            <footer class="footer">
                <BContainer>
                    <BRow>
                        <BCol lg="12">
                            <div class="text-center">
                                <p class="mb-0">&copy; 2026 Cafeman. Seluruh Hak Cipta Dilindungi.</p>
                            </div>
                        </BCol>
                    </BRow>
                </BContainer>
            </footer>
        </div>
    </loading>
</template>